import { Pipe, PipeTransform } from '@angular/core';

interface Translations {
    [key: string]: string;
}

@Pipe({ name: 'translateIso' })
export class TranslateIsoPipe implements PipeTransform {

    private translations: Translations = {
        'aa': 'LANGS.aa',
        'ab': 'LANGS.ab',
        'ae': 'LANGS.ae',
        'af': 'LANGS.af',
        'ak': 'LANGS.ak',
        'am': 'LANGS.am',
        'an': 'LANGS.an',
        'ar': 'LANGS.ar',
        'as': 'LANGS.as',
        'av': 'LANGS.av',
        'ay': 'LANGS.ay',
        'az': 'LANGS.az',
        'ba': 'LANGS.ba',
        'be': 'LANGS.be',
        'bg': 'LANGS.bg',
        'bh': 'LANGS.bh',
        'bi': 'LANGS.bi',
        'bm': 'LANGS.bm',
        'bn': 'LANGS.bn',
        'bo': 'LANGS.bo',
        'br': 'LANGS.br',
        'bs': 'LANGS.bs',
        'ca': 'LANGS.ca',
        'ce': 'LANGS.ce',
        'ch': 'LANGS.ch',
        'co': 'LANGS.co',
        'cr': 'LANGS.cr',
        'cs': 'LANGS.cs',
        'cu': 'LANGS.cu',
        'cv': 'LANGS.cv',
        'cy': 'LANGS.cy',
        'da': 'LANGS.da',
        'de': 'LANGS.de',
        'dv': 'LANGS.dv',
        'dz': 'LANGS.dz',
        'ee': 'LANGS.ee',
        'el': 'LANGS.el',
        'en': 'LANGS.en',
        'eo': 'LANGS.eo',
        'es': 'LANGS.es',
        'et': 'LANGS.et',
        'eu': 'LANGS.eu',
        'fa': 'LANGS.fa',
        'ff': 'LANGS.ff',
        'fi': 'LANGS.fi',
        'fj': 'LANGS.fj',
        'fo': 'LANGS.fo',
        'fr': 'LANGS.fr',
        'fy': 'LANGS.fy',
        'ga': 'LANGS.ga',
        'gd': 'LANGS.gd',
        'gl': 'LANGS.gl',
        'gn': 'LANGS.gn',
        'gu': 'LANGS.gu',
        'gv': 'LANGS.gv',
        'ha': 'LANGS.ha',
        'he': 'LANGS.he',
        'hi': 'LANGS.hi',
        'ho': 'LANGS.ho',
        'hr': 'LANGS.hr',
        'ht': 'LANGS.ht',
        'hu': 'LANGS.hu',
        'hy': 'LANGS.hy',
        'hz': 'LANGS.hz',
        'ia': 'LANGS.ia',
        'id': 'LANGS.id',
        'ie': 'LANGS.ie',
        'ig': 'LANGS.ig',
        'ii': 'LANGS.ii',
        'ik': 'LANGS.ik',
        'io': 'LANGS.io',
        'is': 'LANGS.is',
        'it': 'LANGS.it',
        'iu': 'LANGS.iu',
        'ja': 'LANGS.ja',
        'jv': 'LANGS.jv',
        'ka': 'LANGS.ka',
        'kg': 'LANGS.kg',
        'ki': 'LANGS.ki',
        'kj': 'LANGS.kj',
        'kk': 'LANGS.kk',
        'kl': 'LANGS.kl',
        'km': 'LANGS.km',
        'kn': 'LANGS.kn',
        'ko': 'LANGS.ko',
        'kr': 'LANGS.kr',
        'ks': 'LANGS.ks',
        'ku': 'LANGS.ku',
        'kv': 'LANGS.kv',
        'kw': 'LANGS.kw',
        'ky': 'LANGS.ky',
        'la': 'LANGS.la',
        'lb': 'LANGS.lb',
        'lg': 'LANGS.lg',
        'li': 'LANGS.li',
        'ln': 'LANGS.ln',
        'lo': 'LANGS.lo',
        'lt': 'LANGS.lt',
        'lu': 'LANGS.lu',
        'lv': 'LANGS.lv',
        'mg': 'LANGS.mg',
        'mh': 'LANGS.mh',
        'mi': 'LANGS.mi',
        'mk': 'LANGS.mk',
        'ml': 'LANGS.ml',
        'mn': 'LANGS.mn',
        'mo': 'LANGS.mo',
        'mr': 'LANGS.mr',
        'ms': 'LANGS.ms',
        'mt': 'LANGS.mt',
        'my': 'LANGS.my',
        'na': 'LANGS.na',
        'nb': 'LANGS.nb',
        'nd': 'LANGS.nd',
        'ne': 'LANGS.ne',
        'ng': 'LANGS.ng',
        'nl': 'LANGS.nl',
        'nn': 'LANGS.nn',
        'no': 'LANGS.no',
        'nr': 'LANGS.nr',
        'nv': 'LANGS.nv',
        'ny': 'LANGS.ny',
        'oc': 'LANGS.oc',
        'oj': 'LANGS.oj',
        'om': 'LANGS.om',
        'or': 'LANGS.or',
        'os': 'LANGS.os',
        'pa': 'LANGS.pa',
        'pi': 'LANGS.pi',
        'pl': 'LANGS.pl',
        'ps': 'LANGS.ps',
        'pt': 'LANGS.pt',
        'qu': 'LANGS.qu',
        'rm': 'LANGS.rm',
        'rn': 'LANGS.rn',
        'ro': 'LANGS.ro',
        'ru': 'LANGS.ru',
        'rw': 'LANGS.rw',
        'sa': 'LANGS.sa',
        'sc': 'LANGS.sc',
        'sd': 'LANGS.sd',
        'se': 'LANGS.se',
        'sg': 'LANGS.sg',
        'sh': 'LANGS.sh',
        'si': 'LANGS.si',
        'sk': 'LANGS.sk',
        'sl': 'LANGS.sl',
        'sm': 'LANGS.sm',
        'sn': 'LANGS.sn',
        'so': 'LANGS.so',
        'sq': 'LANGS.sq',
        'sr': 'LANGS.sr',
        'ss': 'LANGS.ss',
        'st': 'LANGS.st',
        'su': 'LANGS.su',
        'sv': 'LANGS.sv',
        'sw': 'LANGS.sw',
        'ta': 'LANGS.ta',
        'te': 'LANGS.te',
        'tg': 'LANGS.tg',
        'th': 'LANGS.th',
        'ti': 'LANGS.ti',
        'tk': 'LANGS.tk',
        'tl': 'LANGS.tl',
        'tn': 'LANGS.tn',
        'to': 'LANGS.to',
        'tr': 'LANGS.tr',
        'ts': 'LANGS.ts',
        'tt': 'LANGS.tt',
        'tw': 'LANGS.tw',
        'ty': 'LANGS.ty',
        'ug': 'LANGS.ug',
        'uk': 'LANGS.uk',
        'ur': 'LANGS.ur',
        'uz': 'LANGS.uz',
        've': 'LANGS.ve',
        'vi': 'LANGS.vi',
        'vo': 'LANGS.vo',
        'wa': 'LANGS.wa',
        'wo': 'LANGS.wo',
        'xh': 'LANGS.xh',
        'yi': 'LANGS.yi',
        'yo': 'LANGS.yo',
        'za': 'LANGS.za',
        'zh': 'LANGS.zh',
        'zu': 'LANGS.zu',
        'mx': 'LANGS.mx',
        'fin': 'LANGS.fin',
    };

    transform(value: string): string {
        return this.translations[value] || value;
    }
}
